import { render, staticRenderFns } from "./AzNewVenue.vue?vue&type=template&id=d5744120&scoped=true&"
import script from "./AzNewVenue.vue?vue&type=script&lang=ts&"
export * from "./AzNewVenue.vue?vue&type=script&lang=ts&"
import style0 from "./AzNewVenue.vue?vue&type=style&index=0&id=d5744120&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5744120",
  null
  
)

export default component.exports